import { render } from "./yc-pl35.vue?vue&type=template&id=75141a77&scoped=true"
import script from "./yc-pl35.vue?vue&type=script&lang=js"
export * from "./yc-pl35.vue?vue&type=script&lang=js"

import "./yc-pl35.vue?vue&type=style&index=0&id=75141a77&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75141a77"]])

export default __exports__